import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { storeToRefs } from 'pinia';
import type { MaybeRef } from 'vue';
import { computed, unref } from 'vue';
import { useLaunchDarkly } from '@getaccept/lib-shared/src/launch-darkly/launch-darkly.composable';
import { RecipientRole } from '@getaccept/lib-shared/src/recipients/enums/recipient-role';
import { RecipientsHelper } from '@getaccept/lib-shared/src/recipients/helpers/recipients.helper';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import { useRootStore } from '../../store/root.store';
import { useDocumentStore } from '../../documents/store/document.store';

export const useInviteAccess = (recipient: MaybeRef<SigningPageRecipient>) => {
  const { isPreview } = storeToRefs(useRootStore());
  const { document } = storeToRefs(useDocumentStore());
  const { flags } = useLaunchDarkly();

  const isSigner = computed(() => unref(recipient).role === RecipientRole.Signer);
  const isInternalApprover = computed(() =>
    RecipientsHelper.isInternalApprover(unref(recipient).role)
  );

  const isDocumentInactive = computed(
    () =>
      document.value?.status &&
      [
        DocumentStatus.Signed,
        DocumentStatus.Recalled,
        DocumentStatus.Rejected,
        DocumentStatus.Lost,
      ].includes(document.value.status)
  );

  const showInvite = computed(
    () => !isInternalApprover.value && !isDocumentInactive.value && !isPreview.value
  );

  const showChangeSigner = computed(
    () =>
      flags.value.signerNewTransferRole &&
      !!document.value?.isSigningForward &&
      showInvite.value &&
      isSigner.value
  );
  const isTransferEnabled = computed(() => showChangeSigner.value && !unref(recipient).signature);

  return { showInvite, showChangeSigner, isTransferEnabled };
};
